import * as React from 'react';
import { connect } from 'react-redux';
import { IRootState } from '../../reducers';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  Glyphicon,
  MenuItem,
  Nav,
  NavItem,
  Navbar,
  NavDropdown,
  } from 'react-bootstrap';
import { logoutAction } from 'src/actions';


interface IProps extends RouteComponentProps {
  accessToken: string;
  userName: string;
  logout: (History: any) => void;
}

interface IState {
  activeKey: string;
}

class Header extends React.Component<IProps, IState> {
  public state = {
    activeKey: 'report'
  }

  constructor(props: any) {
    super(props)
  }

  public handleLogOutClick = () => {
    this.props.logout(this.props.history);
  }

  public handleNavbarClick = (key: any) => {
    this.setState({activeKey: key})
    switch (key) {
      case 'report':
        this.props.history.push("/report");
        return;
      case 'identities':
        this.props.history.push("/identities");
        return;        
    }

    
  }

  public render() {
    const { userName } = this.props;

    return (
      userName && (
        <Navbar 
          className="navbar-main"
          collapseOnSelect = {true}
          fluid = {true}
          fixedTop = {true}
          onSelect={this.handleNavbarClick}>
          <Navbar.Collapse>
            <Nav>
              <NavItem eventKey={'report'} active={this.state.activeKey === 'report'}>
                Reports
            </NavItem>
              <NavItem eventKey={'identities'} active={this.state.activeKey === 'identities'}>
                Identities
            </NavItem>
            </Nav>
            <Nav pullRight = {true}>
              <NavDropdown
                id=''
                eventKey={3}
                title={
                  <span>
                    <Glyphicon glyph="user" />
                    &nbsp;
                    <span>{userName}</span>
                  </span>
                }
              >
                <MenuItem onClick={this.handleLogOutClick}>Logout</MenuItem>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      )
    );
  }
}

const mapStateToProps = (state: IRootState) => ({
  accessToken: state.authState.accessToken,
  userName: state.authState.userName
});

export default connect(mapStateToProps, { logout: logoutAction })(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx